import styles from './styles.module.css'
import { memo } from 'react'

const ItemCard = ({ label: Label, children, isFullHeight = false }) => {
  return (
    <div className={styles.itemColumn}>
      <div className={`itemCardLabelTop ${styles.itemTop}`}>
        <Label />
      </div>
      <div
        className={`itemCardBottom ${styles.itemBottom} ${isFullHeight ? styles.isFullHeight : ''}`}
      >
        {children}
      </div>
    </div>
  )
}

export default memo(ItemCard)
